export default "__VITE_ASSET__f0683a3b__"